import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';
import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit'; // Import fontkit for custom font handling
import Majalla from '../fonts/majalla.ttf';
import Majallabold from '../fonts/majallab.ttf';
import ArialNormal from '../fonts/ARIALNormal.ttf';
import RockWell from '../fonts/ROCK.TTF';
import SakkalMajalla from '../fonts/sakkalmajalla.ttf';
import SakkalMajallaBold from '../fonts/sakkal-majalla-bold.ttf';
import MarkCertificates from '../pdf/Marksheet.pdf';
// Path to existing PDF template
import MarkCertificate1 from '../pdf/Marksheet1.pdf';
import { buttonBackgroundColor } from '../common';

const MarkCertificate = forwardRef(({ dataProp }, ref) => {
    const [open, setOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [serialNumber, setSerialNumber] = useState(1);
    const [studentName, setStudentName] = useState(""); // State to manage the serial number

    // Helper function to format the date with ordinal and month in words
    const formatDateWithOrdinal = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) {
            console.error('Invalid date:', dateStr);
            return 'Invalid Date';
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-GB', { month: 'long' }); // Month as full word
        const year = date.getFullYear();
        const daySuffix = getOrdinalSuffix(day); // Get the ordinal suffix for the day

        return `${day} ${month} ${year}`;
    };

    // Helper function to get ordinal suffix
    const getOrdinalSuffix = (day) => {
        if (day > 3 && day < 21) return 'th'; // Special case for 11th-13th
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    // Function to calculate completion date based on commencement date and type (diploma or advance_diploma)
    const calculateCompletionDate = (commencementDate, type) => {
        const commencement = new Date(commencementDate);
        let completion;

        if (type === 'diploma') {
            completion = new Date(commencement);
            completion.setFullYear(commencement.getFullYear() + 1);
            completion.setDate(completion.getDate() - 1);
        } else if (type === 'advance_diploma') {
            completion = new Date(commencement);
            completion.setMonth(commencement.getMonth() + 6);
            completion.setDate(completion.getDate() - 1);
        } else {
            completion = commencement; // Default to the commencement date if type is not specified
        }

        return completion.toISOString().split('T')[0]; // Return formatted YYYY-MM-DD date
    };

    // Function to get the grade based on total marks
    const getGrade = (totalMarks) => {
        if (totalMarks >= 90) return 'A*';
        if (totalMarks >= 80) return 'A';
        if (totalMarks >= 70) return 'B';
        if (totalMarks >= 60) return 'C';
        if (totalMarks >= 50) return 'D';
        if (totalMarks >= 49) return 'P'; // Pass at Supplementary Examination
        return 'F'; // 49 and below
    };

    // Function to generate the serial number based on the current date and incrementing number
    const generateSerialNumber = (intakeId, studentName, date1, studentNames, id) => {

        const sortedByName = [...studentNames].sort((a, b) => a.name.localeCompare(b.name));
        console.log("Sorted by Name:", sortedByName);

        console.log(date1, "date1")
        // const student1 = studentNames.find(student => student.id === id);
        const index = sortedByName.findIndex(student => student.id === id);
        // student1.index

        // console.log(lastModuleEndDate, "id");
        // console.log(nextMonthDate, "student1.index");
        // // const nextMonthDate = lastModuleEndDate;
        // // Set date to 5th and add one month

        // // if (isNaN(nextMonthDate.getTime())) {
        // //     console.error("Invalid date format:", lastModuleEndDate);
        // //     return null; // Return null or handle error
        // // }
        // nextMonthDate.setDate(5);
        // nextMonthDate.setMonth(lastModuleEndDate.getMonth() + 1);
        // // Check if the new month has fewer days than the original date
        // if (nextMonthDate.getMonth() !== (lastModuleEndDate.getMonth() + 1) % 12) {
        //     nextMonthDate.setDate(0); // Move to the last day of the previous month
        //     nextMonthDate.setDate(5); // Then set to the 5th day of that month
        // }
        // console.log(nextMonthDate, "nextMonthDate");
        // // Add 15 days
        // nextMonthDate.setDate(nextMonthDate.getDate() + 15);
        // const formattedNextMonthDate = nextMonthDate.toLocaleDateString('en-US');
        // console.log(formattedNextMonthDate, "formattedNextMonthDate");
        // const currentDate = new Date();
        // const year = currentDate.getFullYear();
        // const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(currentDate.getDate()).padStart(2, '0'); // Get the day of the month and pad to 2 digits

        // Extract letters from the intakeId using a regex
        const formattedCourseName = intakeId ? intakeId.match(/[A-Za-z]+/)?.[0].toUpperCase() : 'DEEE'; // Use only letters from intakeId
        const parts = intakeId.split("-"); // Split by '-'
        const numberPart = parts[parts.length - 1];
        console.log('numberPart', numberPart)
        // Generate a unique number based on the entire student name
        const nameValue = studentName
        // const name = studentName.sort();
        // .toUpperCase() // Convert to uppercase for consistency
        // .split('') // Split into individual characters
        // .reduce((acc, char) => acc + (char.charCodeAt(0) - 64), 0); // Convert each char to A=1, B=2, etc. and sum them up
        // console.log("studentName:",name)
        // Ensure the nameValue is between 1 and 100 by using modulo
        // const uniqueNumber = (nameValue % 100) + 1;

        const dateObj = new Date(date1);

        // Extract year & month
        const year1 = dateObj.getFullYear(); // 2025
        const month1 = String(dateObj.getMonth() + 1).padStart(2, '0'); // 09 (Months are 0-indexed)

        // Output
        console.log(year1, month1); // 2025 09
        // Generate the serial number
        return `JA-${formattedCourseName}-${year1}-${month1}-${numberPart}${String(index + 1).padStart(2, '0')}`;
    };


    const wrapText = (text, font, maxWidth, fontSize) => {
        const lines = [];
        let currentLine = '';
        // Iterate through each word
        const words = text.split(' ');
        for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            // Check if the test line exceeds the max width
            if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
                currentLine = testLine; // Line fits within max width
            } else {
                if (currentLine) {
                    lines.push(currentLine); // Push the previous line to lines array
                }
                currentLine = word; // Start a new line with the current word
            }
        }
        // Push the last line
        if (currentLine) {
            lines.push(currentLine);
        }
        return lines;
    };
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return date.toLocaleDateString('en-GB', options);
    };

    // const handleDownload = () => {
    //     if (pdfUrl) {
    //         const link = document.createElement('a');
    //         link.href = pdfUrl;
    //         link.download = `Marksheet_${studentName}.pdf`; // Download with student name as filename
    //         link.click();
    //     }
    // };

    useImperativeHandle(ref, () => ({
        handleDownload: async (student, studentNames) => {
            const handlePdfEdit = async () => {
                console.log("student1:", studentNames)
                console.log("student:", student)
                try {
                    let existingPdfBytes;
                    let pdfChanged = false;

                    if (student?.name.length < 28) {
                        // console.log("student name length: if" + student?.name.length);
                        // existingPdfBytes = await fetch(MarkCertificates).then(res => res.arrayBuffer());
                        existingPdfBytes = await fetch(MarkCertificates).then(res => res.arrayBuffer());
                        pdfChanged = false;

                    } else {
                        // console.log("student name length: else" + student?.name.length);
                        // Default fetch if name length is less than or equal to 20
                        existingPdfBytes = await fetch(MarkCertificate1).then(res => res.arrayBuffer());
                        pdfChanged = true;
                    }

                    const pdfDoc = await PDFDocument.load(existingPdfBytes);
                    pdfDoc.registerFontkit(fontkit);


                    const majallaFontBytes = await fetch(Majalla).then(res => res.arrayBuffer());
                    const majallaFont = await pdfDoc.embedFont(majallaFontBytes);

                    const majallaBoldFontBytes = await fetch(Majallabold).then(res => res.arrayBuffer());
                    const majallaBoldFont = await pdfDoc.embedFont(majallaBoldFontBytes);

                    const arialFontBytes = await fetch(ArialNormal).then(res => res.arrayBuffer());
                    const arialFont = await pdfDoc.embedFont(arialFontBytes);

                    const rockwellFontBytes = await fetch(RockWell).then(res => res.arrayBuffer());
                    const rockwellFont = await pdfDoc.embedFont(rockwellFontBytes);

                    const sakkalmajalla = await fetch(SakkalMajalla).then(res => res.arrayBuffer());
                    const sakkFont = await pdfDoc.embedFont(sakkalmajalla);

                    const sakkalmajallabold = await fetch(SakkalMajallaBold).then(res => res.arrayBuffer());
                    const sakkFontbold = await pdfDoc.embedFont(sakkalmajallabold);

                    const [page] = pdfDoc.getPages();
                    const fontSize = 16;

                    // Use the correct date calculations
                    const commencementDate = formatDateWithOrdinal(student.scheduleDate?.[0]?.startDate || new Date());
                    // const completionDate = formatDateWithOrdinal(calculateCompletionDate(student.scheduleDate?.[0]?.startDate || new Date(), student.type));
                    const completionDate = formatDateWithOrdinal(calculateCompletionDate(student.scheduleDate[0]?.startDate, student.type));
                    console.log(completionDate, "completionDate");
                    // Generate and draw the serial number
                    const lastModuleEndDate = new Date(student.scheduleDate[student.scheduleDate.length - 1].endDate);
                    const nextMonthDate = new Date(lastModuleEndDate);
                    nextMonthDate.setDate(5);
                    nextMonthDate.setMonth(lastModuleEndDate.getMonth() + 1);
                    // Check if the new month has fewer days than the original date
                    if (nextMonthDate.getMonth() !== (lastModuleEndDate.getMonth() + 1) % 12) {
                        nextMonthDate.setDate(0); // Move to the last day of the previous month
                        nextMonthDate.setDate(5); // Then set to the 5th day of that month
                    }
                    console.log(nextMonthDate, "nextMonthDate");
                    // Add 15 days
                    nextMonthDate.setDate(nextMonthDate.getDate() + 15);
                    const formattedNextMonthDate = nextMonthDate.toLocaleDateString('en-US');
                    console.log(formattedNextMonthDate, "formattedNextMonthDate");
                    // const date1 = formatDateWithOrdinal(formattedNextMonthDate);
                    const serial = generateSerialNumber(student.intakeId, student.name, formattedNextMonthDate, studentNames, student.id);

                    page.drawText(`${serial}`, { x: pdfChanged ? 464 : 458, y: pdfChanged ? 749 : 750, size: 13, font: majallaFont, color: rgb(0, 0, 0) });

                    if (pdfChanged) {
                        page.drawText(`${student?.name.toUpperCase()}`, { x: 144, y: 572, size: 12, font: arialFont, color: rgb(0, 0, 0) });

                    }
                    else {
                        page.drawText(`${student?.name.toUpperCase()}`, { x: 145, y: 576, size: 12, font: arialFont, color: rgb(0, 0, 0) });

                    }
                    // Draw the student's name and NRIC
                    // page.drawText(`${student?.name.toUpperCase()}`, { x: 140, y: 576, size: 12, font: arialFont, color: rgb(0, 0, 0) });
                    page.drawText(`${student.nric.toUpperCase()}`, { x: pdfChanged ? 139 : 143, y: pdfChanged ? 540 : 544, size: 12, font: arialFont, color: rgb(0, 0, 0) });
                    // page.drawText(`${student.batch?.course}`, { x: 58, y: 250, size: 14, font: majallaBoldFont, color: rgb(0, 0, 0) });

                    // Use the formatted course name based on intakeId
                    const course = student.batch?.course || '';
                    console.log("course:", course)
                    const courseFontSize = 16;
                    const dateFontSize = 16;

                    // Measure course name width separately
                    const courseWidth = majallaBoldFont.widthOfTextAtSize(course, courseFontSize);

                    // Positioning
                    const xPosition = pdfChanged ? 57 : 58;
                    const yposition = 250;

                    // Draw the course name
                    page.drawText(course, {
                        x: xPosition,
                        y: yposition,
                        size: courseFontSize,
                        font: sakkFontbold,
                        color: rgb(0, 0, 0),
                    });

                    // Underline ONLY the course name
                    page.drawLine({
                        start: { x: xPosition, y: yposition - 2 },
                        end: { x: xPosition + courseWidth, y: yposition - 2 },
                        thickness: 1,
                        color: rgb(0, 0, 0),
                    });

                    // Calculate spacing and position for completion date
                    const spaceBetweenText = 5; // Adjust space between course and date
                    const dateXPosition = xPosition + courseWidth + spaceBetweenText;
                    const date1 = formatDateWithOrdinal(formattedNextMonthDate);
                    // Draw the completion date in different font and size
                    page.drawText(`On ${date1}`, {
                        x: dateXPosition,
                        y: yposition,
                        size: dateFontSize,
                        font: sakkFontbold, // Different font
                        color: rgb(0.2, 0.2, 0.2),
                    });



                    // const lastModuleEndDate = new Date(student.scheduleDate[student.scheduleDate.length - 1].endDate);
                    // console.log(lastModuleEndDate, "lastModuleEndDate");
                    // const nextMonthDate = new Date(lastModuleEndDate);
                    // // Set date to 5th and add one month
                    // nextMonthDate.setDate(5);
                    // nextMonthDate.setMonth(lastModuleEndDate.getMonth() + 1);
                    // // Check if the new month has fewer days than the original date
                    // if (nextMonthDate.getMonth() !== (lastModuleEndDate.getMonth() + 1) % 12) {
                    //   nextMonthDate.setDate(0); // Move to the last day of the previous month
                    //   nextMonthDate.setDate(5); // Then set to the 5th day of that month
                    // }
                    // console.log(nextMonthDate, "nextMonthDate");
                    // // Add 15 days
                    // nextMonthDate.setDate(nextMonthDate.getDate() + 15);
                    // const formattedNextMonthDate = nextMonthDate.toLocaleDateString('en-US');
                    // console.log(formattedNextMonthDate, "formattedNextMonthDate");
                    // const confermentDate = formatDate(formattedNextMonthDate);

                    // Use the calculated dates for commencement and completion
                    page.drawText(`${commencementDate}`, { x: pdfChanged ? 477 : 465, y: pdfChanged ? 541 : 578, size: 15, font: sakkFont, color: rgb(0, 0, 0) });
                    page.drawText(`${completionDate}`, { x: pdfChanged ? 477 : 465, y: pdfChanged ? 518 : 547, size: 15, font: sakkFont, color: rgb(0, 0, 0) });
                    // page.drawText(`${completionDate}`, { x: 270, y: 250, size: 16, font: majallaFont, color: rgb(0, 0, 0) });

                    // Draw marks and grades for each module
                    let yPosition = 459; // Starting Y position for marks
                    student.moduleMarks.forEach(module => {
                        // Calculate the total of mark1 and mark2
                        const totalMarks = ((parseFloat(module.mark1) || 0) + (parseFloat(module.mark2) || 0)).toString().padStart(2, '0');
                        const grade = getGrade(totalMarks); // Get the grade based on total marks

                        page.drawText(`${module.moduleName}`, { x: 68, y: yPosition, size: fontSize, font: majallaFont, color: rgb(0.3, 0.3, 0.3) });
                        page.drawText(`${totalMarks}`, { x: 463, y: yPosition, size: fontSize, font: sakkFont, color: rgb(0.3, 0.3, 0.3) });
                        page.drawText(`${grade}`, { x: 540, y: yPosition, size: fontSize, font: sakkFont, color: rgb(0.3, 0.3, 0.3) });

                        yPosition -= 29; // Adjust position for the next module
                    });

                    // Save the edited PDF
                    const pdfBytes = await pdfDoc.save();
                    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);

                    setPdfUrl(pdfUrl);
                    setStudentName(student.name); // Set the student's name for filename
                    setOpen(true);

                    // Increment the serial number for the next certificate
                    setSerialNumber((prev) => prev + 1);
                } catch (error) {
                    console.error('Error generating PDF:', error);
                }
            };

            handlePdfEdit();
        },
    }));

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={{ width: '80%', height: '80%', margin: 'auto', marginTop: '5%', position: 'relative' }}>

                {/* PDF Iframe */}
                <iframe
                    src={pdfUrl}
                    style={{ width: '100%', height: '100%' }}
                    title="Marksheet PDF"
                />

                {/* Buttons container */}
                <Box sx={{
                    position: 'absolute',
                    bottom: '10px',
                    left: '10px',
                    display: 'flex',
                    gap: 2
                }}>
                    {/* Download Button */}
                    <Button
                        variant="contained"
                        style={{backgroundColor:buttonBackgroundColor }}
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = pdfUrl;
                            link.download = `Marksheet_${studentName}.pdf`; // You can customize this filename
                            link.click();
                        }}
                    >
                        Download
                    </Button>

                    {/* Cancel Button */}
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
});

export default MarkCertificate;

